import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ConnectedRouter} from 'connected-react-router/immutable';

import Home from './Home';
import Page from './Page';
import Card from './Card';
import Review from './Review';
import Off from './Off';
import NotFound from './NotFound';
import Loader from './common/Loader';
import {NotifyService} from 'common/notify/immutable';

import * as selector from '../selectors';
import * as action from '../actions';

const mapStateToProps = state => {
	return {
		//ready: selector.getAppReady(state),
		settingsState: selector.getSettingsState(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		presetSettings: action.loadSettings.success,
		loadSettings: action.loadSettings.request,
	}, dispatch);
};

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		history: PropTypes.object,
		// ready: PropTypes.bool,
		settingsState: PropTypes.object,
		presetSettings: PropTypes.func,
		loadSettings: PropTypes.func,
	};

	componentDidMount() {
		if (window.settings) {
			this.props.presetSettings({data: window.settings});
		} else {
			this.props.loadSettings();
		}
	}

	render() {
		const {
			history,
			settingsState
		} = this.props;

		const loading = settingsState.get('loading');
		const settings = settingsState.get('data').toJS();
		const on = !!Number(settings.on);

		if (settings.title) {
			document.title = settings.title;
		}

		const themeClass = 'theme theme-' + (settings.theme || 'light');

		return (
			<ConnectedRouter history={history}>
				<Fragment>
					{!loading && on && (
						<div className={themeClass}>
							<Switch>
								<Route exact path='/' component={Home} />
								<Route path='/card' component={Card} />
								<Route path='/review' component={Review} />
								<Route component={!Number(settings.book_off) ? Page : NotFound} />
							</Switch>
						</div>
					)}

					{!loading && !on && (
						<Off />
					)}

					<Loader loading={loading} />
					<NotifyService />
				</Fragment>
			</ConnectedRouter>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/App.js